import { render } from "./weChatBind.vue?vue&type=template&id=33570436&scoped=true"
import script from "./weChatBind.vue?vue&type=script&lang=js"
export * from "./weChatBind.vue?vue&type=script&lang=js"

import "./weChatBind.vue?vue&type=style&index=0&id=33570436&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33570436"]])

export default __exports__